var Request = require('../helper/request');

function PasswordAssignment(app, userId){
  var self = this;
  self.request = new Request(app);
  self.userId = userId;

  self.routes = {
    create: {
      url: '/iam/user/'+self.userId+'/password_assignment',
      method: 'POST'
    }
  }
}

PasswordAssignment.prototype.create = function(data){
  var self = this;
  return self.request.post(self.routes.create.url, {
    password_assignment: data
  });
}

module.exports = PasswordAssignment;
